
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Facebook, Mail, Phone, Shield } from 'lucide-react';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-[#0B1939] text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-10">
          <div className="col-span-1 md:col-span-1 lg:col-span-1">
            <Link to="/" className="inline-block mb-4">
              <span className="text-2xl font-medium font-ibm">
                Think<span className="text-brand-teal">Tomorrow</span>.AI
              </span>
            </Link>
            <p className="text-gray-300 mb-4">
              Helping SMBs adopt AI for strategy and execution.
              We make AI simple, scalable, and impactful.
            </p>
            <div className="flex space-x-4">
              <a 
                href="https://www.facebook.com/profile.php?id=61571630487367" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-300 hover:text-brand-teal transition-colors"
                aria-label="Facebook"
              >
                <Facebook size={20} />
              </a>
              <a 
                href="mailto:connect@thinktomorrow.ai" 
                className="text-gray-300 hover:text-brand-teal transition-colors"
                aria-label="Email"
              >
                <Mail size={20} />
              </a>
              <a 
                href="tel:+64212763763" 
                className="text-gray-300 hover:text-brand-teal transition-colors"
                aria-label="Phone"
              >
                <Phone size={20} />
              </a>
            </div>
          </div>
          
          <div>
            <h3 className="text-lg font-medium font-ibm mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-300 hover:text-brand-teal transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-gray-300 hover:text-brand-teal transition-colors">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-brand-teal transition-colors">
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/glossary" className="text-gray-300 hover:text-brand-teal transition-colors">
                  Glossary of Terms Used
                </Link>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-lg font-medium font-ibm mb-4">Our Digital Services</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/services#digital-essentials" className="text-gray-300 hover:text-brand-teal transition-colors">
                  Digital Essentials
                </Link>
              </li>
              <li>
                <Link to="/services#digital-growth" className="text-gray-300 hover:text-brand-teal transition-colors">
                  Digital Growth
                </Link>
              </li>
              <li>
                <Link to="/services#digital-pro" className="text-gray-300 hover:text-brand-teal transition-colors">
                  Digital Pro
                </Link>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-lg font-medium font-ibm mb-4">Contact Us</h3>
            <ul className="space-y-2">
              <li>
                <a href="mailto:connect@thinktomorrow.ai" className="flex items-center text-gray-300 hover:text-brand-teal transition-colors">
                  <Mail size={18} className="text-brand-teal mr-2" />
                  connect@thinktomorrow.ai
                </a>
              </li>
              <li>
                <a href="tel:+64212763763" className="flex items-center text-gray-300 hover:text-brand-teal transition-colors">
                  <Phone size={18} className="text-brand-teal mr-2" />
                  021-276-3763
                </a>
              </li>
              <li className="mt-4">
                <a href="https://app.thinktomorrow.ai/" className="flex items-center text-gray-300 hover:text-brand-teal transition-colors">
                  <span className="text-brand-teal mr-2">→</span>
                  Login
                </a>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-700 mt-10 pt-8 flex flex-col md:flex-row justify-between items-center">
          <div className="flex items-center gap-4 mb-4 md:mb-0">
            <p className="text-gray-400 text-sm">
              &copy; {currentYear} ThinkTomorrow.AI. All rights reserved.
            </p>
            <Link 
              to="/learn/admin/login" 
              className="text-gray-400 text-xs opacity-20 hover:opacity-40 transition-all duration-300 flex items-center gap-1"
              aria-label="Admin Portal"
            >
              <Shield size={12} />
              <span>Admin</span>
            </Link>
          </div>
          <div className="flex space-x-6 items-center">
            <Link to="/privacy" className="text-gray-400 text-sm hover:text-brand-teal transition-colors">
              Privacy Policy
            </Link>
            <Link to="/terms" className="text-gray-400 text-sm hover:text-brand-teal transition-colors">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
